import Vue from 'vue'
import DataService from '@/services/DataService'
import SharedService from '@/services/SharedService'

export default {

  // current node environment
  env: process.env.NODE_ENV,
  // get member profile
  // @param id - member id (optional),
  // @return Promise - target user or current auth user if unspecified
  getProfile(id = null) {
    if (this.env === 'ci') {
      return Promise.resolve(DataService.Profile)
    } else {
      if (!id) {
        return Vue.http.get('me')
          .then(SharedService.extractData)
      } else {
        return Vue.http.get('users/' + id)
          .then(SharedService.extractData)
      }
    }
  },

  // get target user token for uber admin to impersonate
  // @params id - member id to impersonate
  impersonateUser(id) {
    if (this.env === 'ci') {
      return Promise.resolve(DataService.ImpersonateProfile)
    } else {
      return Vue.auth.impersonate({ params: { id: id } })
        .then(SharedService.extractData)
    }
  },

  // logout impersonated user
  // @params id - member id to stop impersonating
  stopImpersonateUser(id) {
    if (this.env === 'ci') {
      return Promise.resolve(DataService.Profile)
    } else {
      return Vue.auth.unimpersonate({ params: { id: id } })
        .then(SharedService.extractData)
    }
  },

  // Returns the best display name possible
  // @params profile - user object
  getDisplayName(profile) {
    let userDisplayName
    if (profile.display_name) {
      userDisplayName = profile.display_name
    } else if (profile.title) {
      userDisplayName = `${profile.title} ${profile.last_name}`
    } else {
      userDisplayName = `${profile.first_name} ${profile.last_name}`
    }
    return userDisplayName
  },
  // Concat flag names to a friendly string
  // @params profile - user object
  getFriendlyFlagNames(profile) {
    let friendlyFlagName = null;
    const publicFlags = profile.flags
      .filter(item => item.id > 2) // removes uber_admin and rti_admin roles
      .sort((a, b) => a.id - b.id)
      .map(item => item.friendly_name)
    let roleNames = publicFlags.join(", ")
    if (roleNames) {
      // multiple roles maps to:
      // Teacher
      // Teacher & Coach
      // Teacher, Coach & Assistant
      friendlyFlagName = roleNames.replace(/,(?=[^,]*$)/, ' &')
    }
    return friendlyFlagName;
  },
  // update user setting for email activity notifications
  // @params userSettings - object
  //    { allowActivityEmail: <bool> }
  updateEmailSettings(userSettings) {
    return Vue.http.post('users/toggle_activity_email', userSettings)
      .then(SharedService.extractData)
  }
}
